import { useState, createContext, useMemo } from "react";
import { useDispatch } from "react-redux";
import {getPermission} from "../store/slice/Permission";

export const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const dispatch = useDispatch();
  const [user, setUser] = useState(
    JSON.parse(localStorage.getItem("identifiant")) || ""
  );
  const [token,setToken] = useState(JSON.parse(localStorage.getItem("token")) || "")

  const values = useMemo(() => {
    return {
      user,
      token,
      setUser,
      login: (user,token) => {
        setUser(user);
        setToken(token);
        dispatch(getPermission(user.permissions))
        localStorage.setItem("identifiant", JSON.stringify(user));
        localStorage.setItem('permissions',JSON.stringify(user.permissions))
        localStorage.setItem("token", JSON.stringify(token));
      },
      logOut: () => {
        localStorage.removeItem("identifiant");
        localStorage.removeItem("token");
        localStorage.removeItem("permissions");
        setUser("");
        setToken(" ");
      },
    };
  }, [user,token]);

  return <AuthContext.Provider value={values}>{children}</AuthContext.Provider>;
};



